export const canFindDeliveryStores = (
  orderType,
  userDeliveryAddress,
  userLocation,
  isStadiumSchema,
) =>
  orderType === "delivery" &&
  !!userDeliveryAddress &&
  (isStadiumSchema ||
    (Number.isFinite(userLocation && userLocation.lat) &&
      Number.isFinite(userLocation && userLocation.lng)));

export const getDeliveryStoreSearchLocation = (
  userDeliveryAddress,
  userLocation,
  isStadiumSchema,
) => ({
  lat: isStadiumSchema ? "" : userLocation.lat,
  lng: isStadiumSchema ? "" : userLocation.lng,
  postalCode: isStadiumSchema ? userDeliveryAddress : userDeliveryAddress.postal,
});

export const prepareDeliveryStores = (
  apiStores,
  userLocation,
  isStadiumSchema,
  calculateDistance,
  setHoursProperties,
) => {
  const preparedStores = apiStores.map((store) => {
    const preparedStore = { ...store };

    if (!isStadiumSchema) {
      const distanceFromUserLocationInMeters = calculateDistance(preparedStore, userLocation);

      preparedStore.distanceFromUserLocationInMeters = distanceFromUserLocationInMeters;
      preparedStore.distanceFromUserLocationInKilometers = (
        distanceFromUserLocationInMeters / 1000
      ).toFixed(1);
      preparedStore.distanceFromUserLocationInMiles = (
        distanceFromUserLocationInMeters * 0.000621371
      ).toFixed(1);
    }

    return setHoursProperties(preparedStore);
  });

  if (!isStadiumSchema) {
    preparedStores.sort(
      (a, b) => a.distanceFromUserLocationInMeters - b.distanceFromUserLocationInMeters,
    );
  }

  return preparedStores;
};

export const getStoredStadiumDeliveryAddress = (storedSchema) => {
  if (!storedSchema) return null;

  try {
    const parsedSchema =
      typeof storedSchema === "string" ? JSON.parse(storedSchema) : storedSchema;

    if (!parsedSchema || parsedSchema.row == null || parsedSchema.seat == null) {
      return null;
    }

    return `${parsedSchema.section}/${parsedSchema.row}/${parsedSchema.seat}`;
  } catch (error) {
    return null;
  }
};
